import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('gmp-config', {
        url: '/gmpconfig',
        component: 'googleMarketplaceConfiguration',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/google-marketplace-configuration/google-marketplace-configuration.state.js